import request from '@/utils/request'

// 单位列表
export function getRole(query) {
  return request({
    url: '/v1.0/iwrs/role/all',
    method: 'get',
    params: query
  })
}

// 权限列表
export function roleList(query) {
  return request({
    url: '/v1.0/iwrs/role/all/authority',
    method: 'get',
    params: query
  })
}

// 新增权限
export function addRole(data) {
  return request({
    url: '/v1.0/iwrs/role/add',
    method: 'post',
    data
  })
}

// 编辑角色
export function editRole(data) {
  return request({
    url: '/v1.0/iwrs/role/update',
    method: 'put',
    data
  })
}

// 删除角色
export function delRole(data) {
  return request({
    url: '/v1.0/iwrs/role/delete',
    method: 'delete',
    data
  })
}

// 详情
export function detailRole(query) {
  return request({
    url: '/v1.0/iwrs/role/detail',
    method: 'get',
    params: query
  })
}

// 导入列表
export function inRoleList(query) {
  return request({
    url: '/v1.0/iwrs/role/can_import_all',
    method: 'get',
    params: query
  })
}

// 所有角色不分页
export function roleListNo(query) {
  return request({
    url: '/v1.0/iwrs/role/all_no_page',
    method: 'get',
    params: query
  })
}

// 导入
export function importRole(data) {
  return request({
    url: '/v1.0/iwrs/role/import',
    method: 'post',
    data
  })
}
